/**
 * en-GB messages added by Phase 3 task K7 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 * Kiosk text is large and simple: short sentences, one idea per screen.
 */
export const k7EnGB = {
    'kiosk.common.ok': 'OK',
    // Welcome and home
    'kiosk.welcome.stale': 'This kiosk has been offline for a long time. Please tell reception.',
    'kiosk.welcome.busy': 'The site is busy at the moment. Please tell reception if you are visiting.',
    'kiosk.welcome.evacuation': 'Evacuation',
    'kiosk.home.delivery': 'I am delivering a parcel',
    // Checks (ADR 0026). The reasons themselves are the `check.*` messages.
    'kiosk.check.seeReceptionTitle': 'Please see reception',
    'kiosk.check.warnTitle': 'Before you continue',
    'kiosk.full.short': 'The site is full',
    'kiosk.full.title': 'The site is full',
    'kiosk.full.message': 'We cannot sign in more visitors at the moment. Please see reception.',
    // Induction step
    'kiosk.induction.subtitle': 'Site induction',
    'kiosk.induction.unavailable': 'The site induction is not available on this kiosk. Please see reception.',
    'kiosk.induction.videoMissing': 'The video is not on this kiosk yet. Please read the text below.',
    'kiosk.induction.pdfNote': 'Please read the induction text below. Ask reception if you would like the document.',
    'kiosk.induction.wait': 'Please wait {seconds} seconds',
    'kiosk.induction.startQuiz': 'Start the questions',
    'kiosk.induction.question': 'Question {n} of {total}',
    'kiosk.induction.chooseMany': 'Choose every answer that is right.',
    'kiosk.induction.finish': 'Finish',
    'kiosk.induction.retryTitle': 'Not quite yet',
    'kiosk.induction.retryMessage': 'Some answers were not right. Please try {count} again.',
    'kiosk.induction.retryButton': 'Try again',
    // Permits step
    'kiosk.permits.title': 'Your permits',
    'kiosk.permits.unavailable': 'Your permits cannot be shown right now. Please see reception before you start work.',
    'kiosk.permits.allAccepted': 'You have accepted all your permits.',
    'kiosk.permits.progress': 'Permit {n} of {total}',
    'kiosk.permits.valid': 'From {from} until {until}',
    'kiosk.permits.conditions': 'Conditions',
    'kiosk.permits.precautions': 'Precautions',
    'kiosk.permits.signHere': 'Sign here to accept, {name}',
    'kiosk.permits.accept': 'I accept this permit',
    // NFC
    'kiosk.nfc.blocked': 'This card has been blocked',
    'kiosk.nfc.unknown': 'Card not recognised',
    'kiosk.nfc.enrolTitle': 'Registering cards',
    'kiosk.nfc.enrolProgress': '{done} of {total} done',
    'kiosk.nfc.enrolTapFor': 'Tap the card for',
    'kiosk.nfc.enrolHold': 'Hold the card against the back of the tablet.',
    'kiosk.nfc.enrolSaving': 'Saving...',
    'kiosk.nfc.enrolOk': 'Card saved.',
    'kiosk.nfc.enrolDone': 'All cards registered',
    'kiosk.nfc.noReader': 'This kiosk has no card reader switched on.',
    // Evacuation
    'kiosk.evacuation.title': 'EVACUATION',
    'kiosk.evacuation.drillTitle': 'FIRE DRILL',
    'kiosk.evacuation.startTitle': 'Start an evacuation',
    'kiosk.evacuation.confirmTitle': 'Start an evacuation?',
    'kiosk.evacuation.confirmMessage': 'This alerts everyone on site and opens the roll call.',
    'kiosk.evacuation.confirmStart': 'Start evacuation',
    'kiosk.evacuation.leave': 'Leave roll call',
    'kiosk.evacuation.leaveTitle': 'Enter the PIN to leave the roll call',
    'kiosk.evacuation.returnBanner': 'Evacuation in progress. Tap to go back to the roll call.',
    'kiosk.evacuation.offline': 'Offline: your marks are saved and will be sent when the network is back.',
    'kiosk.evacuation.localOnly': 'Started on this kiosk while offline. It will be merged with the portal when the network is back.',
    'kiosk.evacuation.countUnaccounted': 'Not yet found',
    'kiosk.evacuation.countSafe': 'Safe',
    'kiosk.evacuation.countMissing': 'Missing',
    'kiosk.evacuation.countTotal': 'On site',
    'kiosk.evacuation.allPoints': 'Everyone',
    'kiosk.evacuation.search': 'Search by name',
    'kiosk.evacuation.onlyOpen': 'Not safe yet',
    'kiosk.evacuation.loading': 'Loading the roll call...',
    'kiosk.evacuation.nobody': 'Nobody to show.',
    'kiosk.evacuation.safe': 'Safe',
    'kiosk.evacuation.markedSafe': 'SAFE (tap to undo)',
    'kiosk.evacuation.missing': 'Missing',
    'kiosk.evacuation.markedMissing': 'MISSING (tap to undo)',
    'kiosk.evacuation.host': 'Host: {name}',
    'kiosk.evacuation.check': 'CHECK',
    'kiosk.evacuation.permits': '{count} open permit(s)',
    // Contactless QR in the corner
    'kiosk.contactless.qrLabel': 'Scan this code with your phone to sign in',
    'kiosk.contactless.scanMe': 'Sign in with your phone',
    // Courier
    'kiosk.courier.whoTitle': 'Who is the parcel for?',
    'kiosk.courier.whoHint': 'Type a few letters of their name.',
    'kiosk.courier.search': 'Name of the person',
    'kiosk.courier.useName': 'Use "{name}"',
    'kiosk.courier.useNameHint': 'Reception will pass it on',
    'kiosk.courier.carrierTitle': 'Which company are you from?',
    'kiosk.courier.forName': 'Parcel for {name}',
    'kiosk.courier.other': 'Other',
    'kiosk.courier.otherLabel': 'Company name',
    'kiosk.courier.countTitle': 'How many parcels?',
    'kiosk.courier.howMany': 'Number of parcels',
    'kiosk.courier.save': 'Done',
    'kiosk.courier.thanks': 'Thank you',
    'kiosk.courier.thanksMessage': 'We have told them their parcel is here.',
    // Hidden support screen
    'kiosk.support.pinTitle': 'Support: enter the PIN',
    'kiosk.support.title': 'Support',
    'kiosk.support.close': 'Close',
    'kiosk.support.network': 'Network',
    'kiosk.support.online': 'Online',
    'kiosk.support.offline': 'Offline',
    'kiosk.support.queue': 'Waiting to be sent',
    'kiosk.support.oldest': 'Oldest waiting since',
    'kiosk.support.none': 'None',
    'kiosk.support.deadLetters': 'Refused by the server (not sent)',
    'kiosk.support.deadHelp': 'These items were refused by the server and stay on this kiosk. Tell your administrator; the device page in the portal shows the count.',
    'kiosk.support.configAge': 'Settings last updated',
    'kiosk.support.ageUnknown': 'Never',
    'kiosk.support.ageMinutes': '{n} minutes ago',
    'kiosk.support.ageHours': '{n} hours ago',
    'kiosk.support.ageDays': '{n} days ago',
    'kiosk.support.nfc': 'Card reader',
    'kiosk.support.nfcReady': 'Ready',
    'kiosk.support.nfcOff': 'Switched off',
    'kiosk.support.nfcNone': 'Not fitted',
    'kiosk.support.media': 'Videos stored',
    'kiosk.support.mediaMb': '{mb} MB',
    'kiosk.support.headcount': 'People on site (this kiosk)',
};
//# sourceMappingURL=k7.js.map